import styled from 'styled-components';

export const AboutHeaderContainer = styled.h1`
    display: flex;
    justify-content: center;
    margin: 50px;
`

export const AboutContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    font-size: 20px;
    margin: 50px;
    padding-top: 10px;
`

export const EbayLink = styled.a`
    display: flex;
    justify-content: center;
    padding-top: 50px;
    cursor: pointer;     
`